<template>
  <span v-bind:class="['state', status.toLowerCase()]">
    <v-icon :color="color">{{ iconName }}</v-icon>
  </span>
</template>

<script>

export default {
  name: 'item-state',
  props: {
    status: { required: true, type: String }
  },
  data() {
    return {}
  },
  computed: {

    iconName () {
      return { up: 'mdi-check-bold', down: 'mdi-alert', unknown: 'mdi-timer-sand' }[this.status.toLowerCase()]
    },

    text () {
      return { up: 'ok', down: 'broken', unknown: 'n/a' }[this.status.toLowerCase()]
    },

    color () {
      return { up: 'green', down: 'red', unknown: 'grey' }[this.status.toLowerCase()]
    }

  }
}

</script>
